export default "__VITE_ASSET__D89_m$$k__"